/**
 * Which tab Share list opens on (g73): Link or Text, as last chosen on this
 * device. An ordinary preference, like the theme: it holds one of two words
 * and never a list, a mode, a link or anything a link grants. Written only
 * when the person picks a tab, never because a dialog opened.
 */

export type ShareTab = "link" | "text";

export const SHARE_TAB_KEY = "trayflux.share-tab";

/** Link on first use, and whenever storage is unreadable or holds something else. */
export function storedShareTab(): ShareTab {
  try {
    return localStorage.getItem(SHARE_TAB_KEY) === "text" ? "text" : "link";
  } catch {
    return "link";
  }
}

export function rememberShareTab(tab: ShareTab): void {
  try {
    localStorage.setItem(SHARE_TAB_KEY, tab);
  } catch {
    // Private browsing, or site data switched off: the dialog opens on Link.
  }
}
